export const distinctArray = (list) => {
  if (!Array.isArray(list)) {
    return [];
  }

  const arraySet = [].concat(list).reduce((itens, item) => {
    itens.add(item);

    return itens;
  }, new Set());

  return Array.from(arraySet.values());
};

export const tryGetListOrEmpty = (list) => {
  return Array.isArray(list) ? list : [];
};

export const paginate = (array, pageSize, page, infinite) => {
  if (!Array.isArray(array)) {
    return {
      items: [],
      page: 0,
      pages: 0,
      allItems: [],
    };
  }

  const limit = pageSize || 10;
  const currentPage = page || 1;

  return {
    items: array.slice(
      infinite ? 0 : (currentPage - 1) * limit,
      currentPage * limit
    ),
    page,
    pages: Math.ceil(array.length / limit),
    allItems: array,
  };
};

export const createRouteConfig = (list, configMap, prefixed = "") => {
  if (!Array.isArray(list) || typeof configMap !== "function") {
    return {};
  }

  return list
    .map(configMap)
    .map(({ rotaPrincipal, fisicalPath, outrasRotas }) => ({
      rotaPrincipal: [prefixed, rotaPrincipal].filter((x) => x).join("-"),
      fisicalPath,
      outrasRotas,
    }))
    .reduce(
      (config, { rotaPrincipal, fisicalPath, outrasRotas }) => ({
        ...config,
        [rotaPrincipal]: { fisicalPath, outrasRotas },
      }),
      {}
    );
};
